import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwComponent } from '@aw/ads-components/aw-parent';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function AwStepperProgressComponent_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "completed");
    ɵngcc0.ɵɵelementEnd();
} }
function AwStepperProgressComponent_li_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "not completed");
    ɵngcc0.ɵɵelementEnd();
} }
function AwStepperProgressComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "span", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, AwStepperProgressComponent_li_2_span_3_Template, 2, 0, "span", 3);
    ɵngcc0.ɵɵtemplate(4, AwStepperProgressComponent_li_2_span_4_Template, 2, 0, "span", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("aw-stepper-progress__step--current", step_r1 === ctx_r0.progressCurrentStep)("aw-stepper-progress__step--complete", ctx_r0.progressCurrentStep > step_r1);
    ɵngcc0.ɵɵattribute("aria-current", step_r1 === ctx_r0.progressCurrentStep || null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("Step ", step_r1, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", step_r1 < ctx_r0.progressCurrentStep);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", step_r1 > ctx_r0.progressCurrentStep);
} }
class AwStepperProgressComponent extends AwComponent {
    constructor() {
        super(...arguments);
        this.progressStepperClasses = '';
        this.progressSteps = [];
        this.progressCurrentStep = 0;
    }
    set progressStepsInput(progressSteps) {
        if (progressSteps) {
            this.progressSteps = Array.from(new Array(+progressSteps)).map((_, i) => i + 1);
        }
    }
    set progressCurrentStepInput(step) {
        this.progressCurrentStep = +step;
    }
}
AwStepperProgressComponent.ɵfac = function AwStepperProgressComponent_Factory(t) { return ɵAwStepperProgressComponent_BaseFactory(t || AwStepperProgressComponent); };
AwStepperProgressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwStepperProgressComponent, selectors: [["aw-stepper-progress"]], inputs: { progressStepperClasses: "progressStepperClasses", progressStepsInput: ["progressSteps", "progressStepsInput"], progressCurrentStepInput: ["progressCurrentStep", "progressCurrentStepInput"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["aria-label", "progress", 1, "aw-stepper-progress", 3, "ngClass"], [3, "aw-stepper-progress__step--current", "aw-stepper-progress__step--complete", 4, "ngFor", "ngForOf"], [1, "visuallyhidden"], [4, "ngIf"]], template: function AwStepperProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ol");
        ɵngcc0.ɵɵtemplate(2, AwStepperProgressComponent_li_2_Template, 5, 8, "li", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.progressStepperClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.progressSteps);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf], encapsulation: 2 });
AwStepperProgressComponent.propDecorators = {
    progressStepperClasses: [{ type: Input }],
    progressStepsInput: [{ type: Input, args: ['progressSteps',] }],
    progressCurrentStepInput: [{ type: Input, args: ['progressCurrentStep',] }]
};
const ɵAwStepperProgressComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwStepperProgressComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwStepperProgressComponent, [{
        type: Component,
        args: [{
                encapsulation: ViewEncapsulation.None,
                selector: 'aw-stepper-progress',
                template: "<div class=\"aw-stepper-progress\" aria-label=\"progress\" [ngClass]=\"progressStepperClasses\">\n    <ol>\n        <li\n            *ngFor=\"let step of progressSteps\"\n            [attr.aria-current]=\"step === progressCurrentStep || null\"\n            [class.aw-stepper-progress__step--current]=\"step === progressCurrentStep\"\n            [class.aw-stepper-progress__step--complete]=\"progressCurrentStep > step\"\n        >\n            <span class=\"visuallyhidden\">Step {{ step }}\n                <span *ngIf=\"step < progressCurrentStep\">completed</span>\n                <span *ngIf=\"step > progressCurrentStep\">not completed</span>\n            </span>\n        </li>\n    </ol>\n</div>\n"
            }]
    }], null, { progressStepperClasses: [{
            type: Input
        }], progressStepsInput: [{
            type: Input,
            args: ['progressSteps']
        }], progressCurrentStepInput: [{
            type: Input,
            args: ['progressCurrentStep']
        }] }); })();

class AwStepperProgressModule {
}
AwStepperProgressModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwStepperProgressModule });
AwStepperProgressModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwStepperProgressModule_Factory(t) { return new (t || AwStepperProgressModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwStepperProgressModule, { declarations: function () { return [AwStepperProgressComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwStepperProgressComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwStepperProgressModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwStepperProgressComponent
                ],
                exports: [
                    AwStepperProgressComponent
                ]
            }]
    }], null, null); })();

export { AwStepperProgressComponent, AwStepperProgressModule };

//# sourceMappingURL=aw-ads-components-aw-stepper-progress.js.map